import cx from 'classnames';
import {FC} from 'react';
import {Typography} from '~library/atoms/Typography';
import {ArrowIcon} from '~library/svg/ArrowIcon';

interface MoreDetailsIndicatorProps {
  preview?: boolean;
}

export const MoreDetailsIndicator: FC<MoreDetailsIndicatorProps> = ({preview}) => (
  <div
    className={cx('design-template__more-details-flex-wrapper', {'invitation-margin': !preview})}
  >
    <Typography
      className="design-template__more-details"
      data-qa-id="more_details_icon"
      variant="label2"
    >
      MORE DETAILS
    </Typography>
    <ArrowIcon className="design-template__more-details-arrow" ratio={0.39} direction="down" />
  </div>
);
